module.exports = __webpack_public_path__ + "img/0x3f3d55028207348ef3c0cF705fa1a2633858C8a9.1f620aed.png";